export default __webpack_public_path__ + "static/media/image.0a969d27.svg";